import Vue from 'vue'

export default {
  list (config = {}) {
    return Vue.http.get('/licensor/dashboard', {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/licensor/dashboard.js